import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-inventory-transfer-line-item-tabs',
  templateUrl: './inventory-transfer-line-item-tabs.component.html',
  styleUrls: ['./inventory-transfer-line-item-tabs.component.scss']
})
export class InventoryTransferLineItemTabsComponent implements OnInit {

  @Input() disabled = false;
  @Input() lineItemId = null;
  @Input() tranHeadId = null;
  @Input() activeTab = 'details';  

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  /**
   * Switch tabs without reloading
   * @param tab
   */
   changeTab(tab: string): void {
    this.activeTab = tab;
    this.router.navigate([`/inventory/transfers/${this.tranHeadId}/line-items/${this.lineItemId + (this.activeTab && this.activeTab != "details" ? "/" + this.activeTab : "" )}`]);
  }
}
